import CustomerForm from '@/components/orders/CustomerForm'
import { Customer, SharedProps } from '@/types'
import { formatName } from '@/utils/format'
import { Head, router } from '@inertiajs/react'
import { Container, Paper, Stack, Title } from '@mantine/core'

interface EditCustomerPageProps extends SharedProps {
  customer: Customer
}

export default function EditCustomerPage({ customer, current_organization }: EditCustomerPageProps) {
  const handleUpdateCustomer = (
    values: Pick<Customer, 'first_name' | 'last_name' | 'phone_number' | 'email' | 'address'>
  ) => {
    router.put(`/organizations/${current_organization!.slug}/customers/${customer.id}`, {
      customer: values,
    })
  }

  return (
    <>
      <Head title={`Modifier ${formatName(customer)} - ${current_organization?.name}`} />

      <Container size="sm">
        <Stack gap="xl">
          <Title>Modifier le client</Title>

          <Paper withBorder radius="md" p="md">
            <CustomerForm
              onSubmit={handleUpdateCustomer}
              initialValues={{
                first_name: customer.first_name,
                last_name: customer.last_name,
                phone_number: customer.phone_number,
                email: customer.email || '',
                address: customer.address || '',
              }}
              submitLabel="Mettre à jour le client"
            />
          </Paper>
        </Stack>
      </Container>
    </>
  )
}
